export default __webpack_public_path__ + "static/media/logo.105b33bd.svg";